var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBenefits(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 198.425 198.425",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_0_53902ff19fa4ac4c60c29004495de731ac78450af33da75ce47bbce40ed16779",
    x1: 103.491,
    y1: -4.58,
    x2: 141.351,
    y2: -4.58,
    gradientTransform: "rotate(-.596 11653.704 895.742)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_53902ff19fa4ac4c60c29004495de731ac78450af33da75ce47bbce40ed16779",
    "data-name": "C_BG_shellbar",
    x1: 67.424,
    y1: -5.125,
    x2: 109.789,
    y2: -5.125,
    xlinkHref: "#SVGID_0_53902ff19fa4ac4c60c29004495de731ac78450af33da75ce47bbce40ed16779"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_53902ff19fa4ac4c60c29004495de731ac78450af33da75ce47bbce40ed16779",
    "data-name": "C_BG_shellbar",
    x1: 84.23,
    y1: -35.925,
    x2: 126.595,
    y2: -35.925,
    xlinkHref: "#SVGID_0_53902ff19fa4ac4c60c29004495de731ac78450af33da75ce47bbce40ed16779"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_53902ff19fa4ac4c60c29004495de731ac78450af33da75ce47bbce40ed16779",
    "data-name": "C_BG_shellbar",
    x1: 53.841,
    y1: 59.547,
    x2: 79.833,
    y2: 59.547,
    xlinkHref: "#SVGID_0_53902ff19fa4ac4c60c29004495de731ac78450af33da75ce47bbce40ed16779"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_53902ff19fa4ac4c60c29004495de731ac78450af33da75ce47bbce40ed16779",
    "data-name": "C_BG_shellbar",
    x1: 113.74,
    y1: 59.547,
    x2: 138.119,
    y2: 59.547,
    xlinkHref: "#SVGID_0_53902ff19fa4ac4c60c29004495de731ac78450af33da75ce47bbce40ed16779"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    d: "M112.479 95.993c10.387.293 18.771 8.75 18.88 19.232.112 10.737-8.502 19.531-19.238 19.643-6.582.068-12.434-3.142-16.003-8.11",
    stroke: "url(#SVGID_0_53902ff19fa4ac4c60c29004495de731ac78450af33da75ce47bbce40ed16779)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    d: "M96.255 103.882a19.84 19.84 0 013.537 11.134c.115 11.008-8.716 20.024-19.724 20.139-11.008.115-20.024-8.716-20.139-19.724-.115-11.008 8.716-20.024 19.724-20.139",
    stroke: "url(#SVGID_1_53902ff19fa4ac4c60c29004495de731ac78450af33da75ce47bbce40ed16779)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M77.109 52.835h-17.86a4.157 4.157 0 00-4.157 4.157v5.116a4.157 4.157 0 004.157 4.157h2.669v7.081c-.111 4.341-3.59 8.357-6.806 11.572l-1.667 1.667c-2.246 2.517-2.469 5.448-2.469 8.439v38.45c0 5.993 4.859 10.852 10.852 10.852h68.306c5.994 0 10.852-4.859 10.852-10.852v-38.45c0-2.991-.224-5.922-2.469-8.439l-1.667-1.667c-3.216-3.215-6.695-7.231-6.806-11.572v-7.081h2.669a4.157 4.157 0 004.157-4.157v-5.116a4.157 4.157 0 00-4.157-4.157h-6.372"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M92.064 62.099v-7.613c0-.643.184-1.273.531-1.815l6.756-10.572"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M148.08 17.64h-30.736c-.288 0-.574.046-.847.136l-17.922 5.891a2.712 2.712 0 00-1.518 1.249L83.15 49.697a2.704 2.704 0 00-.347 1.327v17.158"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    d: "M101.017 64.568c8.674 2.085 15.16 9.848 15.257 19.174.115 11.008-8.716 20.024-19.724 20.139-11.008.115-20.024-8.716-20.139-19.724-.093-8.94 5.714-16.566 13.795-19.177",
    stroke: "url(#SVGID_2_53902ff19fa4ac4c60c29004495de731ac78450af33da75ce47bbce40ed16779)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M100.105 82.306s-.671-3.86-3.864-3.857c-3.193.003-4.048 3.864-4.048 3.864l8.299 6.28M92.58 88.601s.671 3.86 3.864 3.857c3.193-.003 4.048-3.864 4.048-3.864M96.333 75.161l.003 3.288M96.349 92.458l.003 3.289M79.861 106.465l2.846 5.766 6.362.924-4.604 4.488 1.087 6.338-5.691-2.992-5.691 2.992 1.087-6.338-4.604-4.488 6.362-.924 2.846-5.766zM111.939 110.191l-.041.043h-.001c-2.196-2.198-5.758-3.343-7.954-1.147a5.625 5.625 0 000 7.954l7.954 7.954 7.954-7.954h-.001l.043-.042a5.625 5.625 0 000-7.954c-2.196-2.196-5.758-1.051-7.954 1.146zM101.155 37.809l-1.631 3.908 1.319 5.288c.228.794.11 1.647-.325 2.35l-10.336 15.58a4.061 4.061 0 00.677 5.8 4.062 4.062 0 005.268-.29l14.655-17.609 16.494-5.887a3.251 3.251 0 001.576-1.006l6.711-5.932a3.245 3.245 0 012.252-1.123l9.393-.601"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    d: "M76.41 66.259H59.236a4.157 4.157 0 01-4.145-4.145V56.98a4.157 4.157 0 014.145-4.145h19.347",
    stroke: "url(#SVGID_3_53902ff19fa4ac4c60c29004495de731ac78450af33da75ce47bbce40ed16779)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    d: "M126.339 52.835h6.385a4.157 4.157 0 014.145 4.145v5.134a4.157 4.157 0 01-4.145 4.145H114.99",
    stroke: "url(#SVGID_4_53902ff19fa4ac4c60c29004495de731ac78450af33da75ce47bbce40ed16779)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M159.789 42.098h-11.458V13.88h11.458v28.218z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefits);
export default __webpack_public_path__ + "static/media/benefits.70cd3909007b653798998e8d07d40fbc.svg";
export { ForwardRef as ReactComponent };